import { graphql } from "gql.tada";
import { SlideCarouselSectionFragment } from "@queries/fragments/SlideCarouselSectionFragment";

export const SlideCarouselSectionById = graphql(
  `
    query SlideCarouselSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      slideCarouselSection(id: $id, preview: $preview, locale: $locale) {
        ...SlideCarouselSectionFragment
      }
    }
  `,
  [SlideCarouselSectionFragment]
);
